const BY_ID = {
  1: true,
  2: true,
  3: true,
  4: true,
};

const BY_NOMBRE = {
  sentido: 1,
  meaning: 1,
  sabio: 1,
  "el sabio": 1,
  "the sage": 1,
  vinculo: 2,
  bond: 2,
  reina: 2,
  "la reina": 2,
  "the queen": 2,
  accion: 3,
  action: 3,
  artesano: 3,
  artesana: 3,
  "la artesana": 3,
  "el artesano": 3,
  "the artisan": 3,
  exploracion: 4,
  exploration: 4,
  aprendiz: 4,
  "el aprendiz": 4,
  "the apprentice": 4,
};

const normalize = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

export function resolveCreatividadId(creatividad) {
  if (!creatividad) return null;
  if (creatividad.id_creatividad && BY_ID[creatividad.id_creatividad]) {
    return creatividad.id_creatividad;
  }
  const key = normalize(creatividad.nombre);
  return BY_NOMBRE[key] || null;
}

/**
 * @param {object} creatividad
 * @param {(key: string, opts?: object) => string} [t] - i18n t; si no hay, fallback ES hardcode
 */
export function getCreatividadLabels(creatividad, t) {
  const id = resolveCreatividadId(creatividad);
  if (id && typeof t === "function") {
    return {
      nombreNuevo: t(`creatividades.${id}.name`),
      nombreAntiguo: t(`creatividades.${id}.legacy`),
      desc: t(`creatividades.${id}.desc`),
    };
  }
  if (id) {
    const fallback = {
      1: { nombreNuevo: "Sentido", nombreAntiguo: "El Sabio", desc: "" },
      2: { nombreNuevo: "Vínculo", nombreAntiguo: "La Reina", desc: "" },
      3: { nombreNuevo: "Acción", nombreAntiguo: "La Artesana", desc: "" },
      4: { nombreNuevo: "Exploración", nombreAntiguo: "El Aprendiz", desc: "" },
    };
    return fallback[id];
  }
  return {
    nombreNuevo: creatividad?.nombre || "—",
    nombreAntiguo: "",
    desc: "",
  };
}
